module.exports = __webpack_public_path__ + "static/assets/802c301699817f9cc8b78e73e5f9c228.svg";